import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Document, Signer } from '@app/models';
import { DocumentService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

export type ModalResult = void;
export interface ModalPublicProperties {
  document: Document;
  currentSigner: Signer;
  filledFields?: boolean;
}

@Component({
  selector: 'app-document-signed-modal',
  templateUrl: './document-signed-modal.component.html',
  styleUrls: ['./document-signed-modal.component.scss'],
  standalone: false
})
export class DocumentSignedModalComponent implements ModalPublicProperties, OnInit {
  @Input() document: Document;
  @Input() currentSigner: Signer;
  @Input() filledFields?: boolean;
  waitingBiometry = false;

  constructor(
    public modal: NgbActiveModal,
    public documentService: DocumentService,
    public translateService: TranslateService
  ) {}

  ngOnInit() {
    if (!!this.currentSigner?.action && (this.currentSigner.verifications || []).length > 0) {
      const pendingVerification = this.documentService.getPendingManualVerification(this.currentSigner);
      this.waitingBiometry = pendingVerification && !pendingVerification.verified_at;
    }
  }

  openSignedDocument() {
    if (this.document && this.document.qualified) {
      window.open(this.documentService.padesDocumentUrl(this.document), 'blank');
    } else {
      window.open(this.documentService.signedDocumentUrl(this.document), 'blank');
    }
    this.modal.close();
  }
}
